var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnQ112(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 54.2,
    viewBox: "0 0 52 54.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.855,
    y1: -0.094,
    x2: 0.094,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#698ed3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(0 0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M1.2,0H41.922a1.2,1.2,0,0,1,1.2,1.2V51.8a1.2,1.2,0,0,1-1.2,1.2H1.2A1.2,1.2,0,0,1,0,51.8V1.2A1.2,1.2,0,0,1,1.2,0Z",
    transform: "translate(4.439)",
    fill: "#e1f4fb",
    stroke: "#e1f4fb",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 34.244,
    height: 44.699,
    rx: 1.2,
    transform: "translate(9.512 4.47)",
    fill: "#fff",
    stroke: "#00a3da",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "flame",
    transform: "translate(21.565 36.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M1.951,11.835A9.183,9.183,0,0,1,.387,9.609a5.079,5.079,0,0,1-.3-2.9,6.284,6.284,0,0,1,1.24-2.687,2.6,2.6,0,0,0,.647,1.9A4.538,4.538,0,0,1,3,2.172,7.7,7.7,0,0,1,6.291,0a2.69,2.69,0,0,0-.458,2.552A10.668,10.668,0,0,0,7.046,4.968a5.415,5.415,0,0,1,.917,2.5,8.758,8.758,0,0,0,.674-1.439,2.861,2.861,0,0,0,.108-1.574,4.05,4.05,0,0,1,.89,1.954,8.271,8.271,0,0,1,.027,2.307,5.8,5.8,0,0,1-.782,2.416,4.5,4.5,0,0,1-2.345,1.764A5.3,5.3,0,0,1,1.951,11.835Z",
    transform: "translate(0)",
    fill: "#f3705a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M1.781,7.356a2.665,2.665,0,0,0,3.181-3.8c0-.027-.027-.027-.027-.054A2.754,2.754,0,0,1,4.261,5.89a2.551,2.551,0,0,0-.243-2.063C3.7,3.2,3.237,2.633,2.886,2.036A2.9,2.9,0,0,1,2.428,0,3.582,3.582,0,0,0,1.134,2.009,3.657,3.657,0,0,0,1.4,4.4a1.787,1.787,0,0,1-.728-1.3A2.807,2.807,0,0,0,0,4.968,2.763,2.763,0,0,0,1.781,7.356Z",
    transform: "translate(2.219 5.483)",
    fill: "#ffd15c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M37.485,21.684H0v-2.5H37.485a1.138,1.138,0,0,0,0-2.275H14.88a3.736,3.736,0,0,1,0-7.471H37.1a1.53,1.53,0,0,0,0-3.06H14.958a3.814,3.814,0,0,1,0-7.628H52v2.5H14.958a1.314,1.314,0,0,0,0,2.628H37.1a4.03,4.03,0,0,1,0,8.06H14.88a1.236,1.236,0,0,0,0,2.471h22.6a3.638,3.638,0,0,1,0,7.275Z",
    transform: "translate(0 11.494)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnQ112);
export default __webpack_public_path__ + "static/media/on_Q1_12_.ecdcfb39e79f8179c475a3ea2bb14404.svg";
export { ForwardRef as ReactComponent };